import React from 'react';
import PropTypes from 'prop-types';

import {Notebook} from '@learningblocks/storybook-components';
import {
  Modal,
  LottiePlayer,
} from '@learningblocks/shared-components';
import { Image } from '@learningblocks/shared-components';
import {Title} from './Title';
import {Wrapper} from './Wrapper';
import {Confetti} from './Confetti';
import {FlaskAnimation} from './FlaskAnimation';
import {Utilities} from '@learningblocks/exp-constants';
const {NOTEBOOK} = Utilities;

import './style.scss';

/**
 * TechniqueViewComplete:
 * - Modal window to popup After compeleting technique view section
 */
export function TechniqueViewComplete(props) {
  const className = `techniqueViewCompleteWindow_wrapper ${props.className}`;

  const onClickNext = () => {
    props.onClickNext(props.nextMenuValue);
  };

  return (
    <Modal isOpen={props.isOpen} className='techniqueViewCompleteWindow'>
      <Wrapper className={className}>
        <Confetti className='techniqueViewCompleteWindow_confetti' />
        <FlaskAnimation className='techniqueViewCompleteWindow_animation' />
        <Title className='techniqueViewCompleteWindow_title' />
        <Notebook.NextSectionButton
          className='techniqueViewCompleteWindow_button'
          onClick={onClickNext}
        />
      </Wrapper>
    </Modal>
  );
}

TechniqueViewComplete.propTypes = {
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool,
  /**
   * Function to trigger next button
   */
  onClickNext: PropTypes.func,
  /**
   * Function to close modal window
   */
  close: PropTypes.func,
  /**
   * ClassName
   */
  className: PropTypes.string,
};

TechniqueViewComplete.defaultProps = {
  isOpen: false,
  className: '',
};
